export default __webpack_public_path__ + "static/media/FATMUG.c2b88bd2.jpg";